const LIBRE_SURVEY_ANSWERS = new Set(['libre1', 'libre2', 'libre3'])

export const isLibreSurveyAnswer = (sensor?: string | null): boolean => {
  if (!sensor) {
    return false
  }

  return LIBRE_SURVEY_ANSWERS.has(sensor)
}
